<details #details>
  <summary>
    <p
      class="title ellipsis"
      [title]="row().localized_name">
      {{ row().localized_name }}
    </p>

    <span class="info">
      @if (content(); as cont) {
        @if (cont.chips.length) {
          <span
            (click)="cont.reset($event, cont)"
            class="chips">
            {{ cont.chips }}
            <mat-icon>close</mat-icon>
          </span>
        }
      }
      <span class="icon"></span>
    </span>
  </summary>

  <div class="filter-content">
    @switch (row().type) {
      @case ('string') {
        <app-f-text
          #content
          [row]="row()" />
      }
      @case ('date') {
        <app-f-date
          #content
          [row]="row()" />
      }
      @case ('select') {
        <app-f-select
          #content
          [row]="row()" />
      }
      @case ('reference') {
        <app-f-reference
          #content
          [opened]="detailsOpen()"
          [row]="row()" />
      }
      @case ('user') {
        <app-f-user
          #content
          [row]="row()" />
      }
    }
  </div>
</details>
